/**
 * @generated SignedSource<<3063f1c6dbd6ffc487b02d401f38b01a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useNotificationsConfig_seller$data = {
  readonly billingProfile: {
    readonly runningBalance: number | null;
  } | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "useNotificationsConfig_seller";
};
export type useNotificationsConfig_seller$key = {
  readonly " $data"?: useNotificationsConfig_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"useNotificationsConfig_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useNotificationsConfig_seller",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BillingProfile",
      "kind": "LinkedField",
      "name": "billingProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "runningBalance",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "d8bfbd36dcbf3eaab3773f6fe7634b4a";

export default node;
